import { Timer } from 'src/models/timer';

import { Callback } from 'src/util/query/models/Callback';

import { SetRunningAppointmentTimerPayload } from '../interfaces';

export class GetRunningAppointmentTimerCallBack extends Callback<Array<Timer>> {
	public constructor(
		private readonly setRunningAppointmentTimer: (payload: SetRunningAppointmentTimerPayload) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<Timer>): void => {
		const processedTimers = successResponse
			.map((timer) => {
				const startTimeString = timer.startTime as unknown as string;
				const endTimeString = timer.endTime as unknown as string;

				const parseUtcAsLocal = (timeString: string): Date => {
					const cleanString = timeString.replace('Z', '');
					const parts = cleanString.split(/[T.:-]/);
					if (parts.length < 6) {
						return new Date(timeString);
					}

					return new Date(
						parseInt(parts[0], 10),
						parseInt(parts[1], 10) - 1,
						parseInt(parts[2], 10),
						parseInt(parts[3], 10),
						parseInt(parts[4], 10),
						parseInt(parts[5], 10) || 0
					);
				};

				const startTime = parseUtcAsLocal(startTimeString);
				let endTime = null;
				if (endTimeString) {
					endTime = parseUtcAsLocal(endTimeString);
				}

				return {
					...timer,
					endTime: endTime,
					startTime: startTime,
				};
			})
			.filter((timer) => timer.endTime === null);

		this.setRunningAppointmentTimer({
			appointmentTimer: processedTimers,
		});
	};
}
